import { IPutTeeSheetSettings } from "api/rpc/2024-04/facilityAdmin/facility/settings";
import FormLayout from "components/form/FormLayout";
import Input from "components/form/input/Input";
import Toggle from "components/form/toggle/Toggle";
import React from "react";
import { useTranslation } from "react-i18next";
import { Select } from "components/select/";
import "./facilitySettings.scss";

interface IProps {
  state: Partial<IPutTeeSheetSettings>;
  updateState: <K extends keyof IPutTeeSheetSettings>(key: K, value: IPutTeeSheetSettings[K]) => void;
}

export default function FacilityGiftCardSettings(props: IProps) {
  const { state, updateState } = props;
  const { t } = useTranslation();
  const { Option } = Select;
  const isCustomYears = state?.gift_card_expiry === "custom_years";

  return (
    <div className="facility-gift-card-settings p-2">
      <FormLayout>
        <FormLayout.Group>
          <Toggle
            labelRight={t("Auto Select Generate Gift Card")}
            onChange={e => updateState("gift_cards_default_auto_generate_code", e.target.checked)}
            checked={state?.gift_cards_default_auto_generate_code}
            tooltip={t("When enabled, new gift cards default to generating a random code at checkout.")}
          />
        </FormLayout.Group>

        <FormLayout.Group alignStart>
          <Select
            label={t("Gift card expiry")}
            defaultValue={state?.gift_card_expiry ?? "no_expiry"}
            onChange={(value: "no_expiry" | "one_year" | "end_of_year" | "custom_years") =>
              updateState("gift_card_expiry", value)
            }
          >
            <Option value="no_expiry">{t("No Expiration")}</Option>
            <Option value="one_year">{t("One Year")}</Option>
            <Option value="end_of_year">{t("End of Year")}</Option>
            <Option value="custom_years">{t("Custom Years")}</Option>
          </Select>

          {isCustomYears ? (
            <div className="facility-gift-card-settings-years">
              <Input
                type="number"
                label={t("Gift card expiry years")}
                value={state?.gift_card_expiry_years ?? 5}
                onChange={e => updateState("gift_card_expiry_years", Number(e.target.value))}
                min={1}
                max={99}
              />
            </div>
          ) : null}
        </FormLayout.Group>
      </FormLayout>

      <p className="facility-gift-card-settings-help-text">
        {t("Default expiry applied when gift cards are sold or reloaded")}
      </p>
    </div>
  );
}
